module.exports = __webpack_public_path__ + "img/message-bot.96f2be5a.svg";